import { createSelector } from '@reduxjs/toolkit';

const getFerryConfig = (state) => state.sealink;
const getSegmentEntities = (state) => state?.sealink?.segments || {};
const getRouteEntities = (state) => state?.routes || {};
const getProductTypeEntities = (state) =>
  getFerryConfig(state)?.product_types || {};

const transferSubroute = ({
  id,
  from_route_stop_qt_id,
  from_route_stop_name,
  to_route_stop_qt_id,
  to_route_stop_name,
  google_map_link,
}) => ({
  id,
  fromRouteStopId: from_route_stop_qt_id,
  fromRouteStopName: from_route_stop_name,
  toRouteStopId: to_route_stop_qt_id,
  toRouteStopName: to_route_stop_name,
  googleMapLink: google_map_link,
});

const getSegments = createSelector(
  [getProductTypeEntities, getRouteEntities, getSegmentEntities],
  (productTypes, routes, segments) =>
    Object.values(segments).map((segment) => {
      const productType = productTypes[segment.product_type];
      const route = routes[segment.qt_route_id];

      return {
        id: segment.id,
        name: segment.name,
        route: {
          id: route.id,
          name: route.name,
        },
        routeStops: route.route_stops
          .slice()
          .sort((a, b) => a.position - b.position),
        productType: {
          id: productType.qt_id,
          name: productType.name,
          mandatoryVehicle: productType.mandatory_vehicle,
        },
        isPrimarySegment: segment.is_primary_segment,
        isReturn: segment.is_return,
        isOptional: segment.is_optional,
        prompt: segment.prompt,
        soldOutToggle: segment.sold_out_toggle,
        googleMapLink: segment.google_map_link,
        subroutes: segment.subroutes?.map(transferSubroute),
      };
    })
);

export { getSegments };
